import React from 'react';

import { SVGComponentProps } from './svg.types';

const AiQueryBotSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M9.99999 15.1663H5.99999C2.37999 15.1663 0.833321 13.6197 0.833321 9.99967V5.99967C0.833321 2.37967 2.37999 0.833008 5.99999 0.833008H9.99999C13.62 0.833008 15.1667 2.37967 15.1667 5.99967V9.99967C15.1667 13.6197 13.62 15.1663 9.99999 15.1663ZM5.99999 1.83301C2.92665 1.83301 1.83332 2.92634 1.83332 5.99967V9.99967C1.83332 13.073 2.92665 14.1663 5.99999 14.1663H9.99999C13.0733 14.1663 14.1667 13.073 14.1667 9.99967V5.99967C14.1667 2.92634 13.0733 1.83301 9.99999 1.83301H5.99999Z"
          fill={fill}
        />
        <path
          d="M10.3333 7C9.50665 7 8.83332 6.32667 8.83332 5.5C8.83332 4.67333 9.50665 4 10.3333 4C11.16 4 11.8333 4.67333 11.8333 5.5C11.8333 6.32667 11.16 7 10.3333 7ZM10.3333 5C10.06 5 9.83332 5.22667 9.83332 5.5C9.83332 5.77333 10.06 6 10.3333 6C10.6067 6 10.8333 5.77333 10.8333 5.5C10.8333 5.22667 10.6067 5 10.3333 5Z"
          fill={fill}
        />
        <path
          d="M5.66666 7C4.83999 7 4.16666 6.32667 4.16666 5.5C4.16666 4.67333 4.83999 4 5.66666 4C6.49332 4 7.16666 4.67333 7.16666 5.5C7.16666 6.32667 6.49332 7 5.66666 7ZM5.66666 5C5.39332 5 5.16666 5.22667 5.16666 5.5C5.16666 5.77333 5.39332 6 5.66666 6C5.93999 6 6.16666 5.77333 6.16666 5.5C6.16666 5.22667 5.93999 5 5.66666 5Z"
          fill={fill}
        />
        <path
          d="M7.99999 12.9662C6.06666 12.9662 4.49999 11.3929 4.49999 9.46621C4.49999 8.85954 4.99332 8.36621 5.59999 8.36621H10.4C11.0067 8.36621 11.5 8.85954 11.5 9.46621C11.5 11.3929 9.93332 12.9662 7.99999 12.9662ZM5.59999 9.36621C5.54666 9.36621 5.49999 9.41288 5.49999 9.46621C5.49999 10.8462 6.61999 11.9662 7.99999 11.9662C9.37999 11.9662 10.5 10.8462 10.5 9.46621C10.5 9.41288 10.4533 9.36621 10.4 9.36621H5.59999Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default AiQueryBotSVG;
